// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
import { useApolloFragment } from 'apollo-fragment-react';


export type MerlinRawLogFragment = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'timestamp' | 'message' | 'sourceStream' | 'command' | 'invocationId'>
);

export type LogsForMerlinSourceEventQueryVariables = Types.Exact<{
  sourceEventId: Types.Scalars['ID'];
  offset?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type LogsForMerlinSourceEventQuery = (
  { __typename?: 'Query' }
  & { logsForMerlinSourceEvent?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'Log' }
    & MerlinRawLogFragment
  )>>> }
);

export type MerlinRawLogsCreatedSubscriptionVariables = Types.Exact<{
  sourceEventId: Types.Scalars['ID'];
}>;


export type MerlinRawLogsCreatedSubscription = (
  { __typename?: 'Subscription' }
  & { merlinRawLogsCreated?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'Log' }
    & MerlinRawLogFragment
  )>>> }
);

export const MerlinRawLogFragmentDoc = gql`
    fragment MerlinRawLog on Log {
  id
  timestamp
  message
  sourceStream
  command
  invocationId
}
    `;
export const LogsForMerlinSourceEventDocument = gql`
    query LogsForMerlinSourceEvent($sourceEventId: ID!, $offset: Int) {
  logsForMerlinSourceEvent(sourceEventId: $sourceEventId, offset: $offset) {
    ...MerlinRawLog
  }
}
    ${MerlinRawLogFragmentDoc}`;

/**
 * __useLogsForMerlinSourceEventQuery__
 *
 * To run a query within a React component, call `useLogsForMerlinSourceEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogsForMerlinSourceEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogsForMerlinSourceEventQuery({
 *   variables: {
 *      sourceEventId: // value for 'sourceEventId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLogsForMerlinSourceEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LogsForMerlinSourceEventQuery, LogsForMerlinSourceEventQueryVariables>) {
        return ApolloReactHooks.useQuery<LogsForMerlinSourceEventQuery, LogsForMerlinSourceEventQueryVariables>(LogsForMerlinSourceEventDocument, baseOptions);
      }
export function useLogsForMerlinSourceEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LogsForMerlinSourceEventQuery, LogsForMerlinSourceEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LogsForMerlinSourceEventQuery, LogsForMerlinSourceEventQueryVariables>(LogsForMerlinSourceEventDocument, baseOptions);
        }
export type LogsForMerlinSourceEventQueryHookResult = ReturnType<typeof useLogsForMerlinSourceEventQuery>;
export type LogsForMerlinSourceEventLazyQueryHookResult = ReturnType<typeof useLogsForMerlinSourceEventLazyQuery>;
export type LogsForMerlinSourceEventQueryResult = ApolloReactCommon.QueryResult<LogsForMerlinSourceEventQuery, LogsForMerlinSourceEventQueryVariables>;
export const MerlinRawLogsCreatedDocument = gql`
    subscription MerlinRawLogsCreated($sourceEventId: ID!) {
  merlinRawLogsCreated(sourceEventId: $sourceEventId) {
    ...MerlinRawLog
  }
}
    ${MerlinRawLogFragmentDoc}`;

/**
 * __useMerlinRawLogsCreatedSubscription__
 *
 * To run a query within a React component, call `useMerlinRawLogsCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMerlinRawLogsCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerlinRawLogsCreatedSubscription({
 *   variables: {
 *      sourceEventId: // value for 'sourceEventId'
 *   },
 * });
 */
export function useMerlinRawLogsCreatedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<MerlinRawLogsCreatedSubscription, MerlinRawLogsCreatedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<MerlinRawLogsCreatedSubscription, MerlinRawLogsCreatedSubscriptionVariables>(MerlinRawLogsCreatedDocument, baseOptions);
      }
export type MerlinRawLogsCreatedSubscriptionHookResult = ReturnType<typeof useMerlinRawLogsCreatedSubscription>;
export type MerlinRawLogsCreatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<MerlinRawLogsCreatedSubscription>;

  /**
   * __useMerlinRawLogFragment__
   * To read a fragment data from Apollo Cache, call `useMerlinRawLogFragment` and pass it the ID of the cached object.
   * When your component renders, `useMerlinRawLogFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useMerlinRawLogFragment('fragment-id');
   */
export function useMerlinRawLogFragment(id: string) {
          return useApolloFragment<MerlinRawLogFragment>(MerlinRawLogFragmentDoc, id);
        }
export type MerlinRawLogFragmentHookResult = ReturnType<typeof useMerlinRawLogFragment>;